export const USERS_API_URL = process.env.REACT_APP_USERS_API_URL_US;
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const DOMAIN = process.env.REACT_APP_DOMAIN;
export const DEVICE_INFO_API_URL = process.env.REACT_APP_DEVICE_INFO_API_URL_US;
export const INVITE_URL = process.env.REACT_APP_INVITE_URL;
export const LOGIN_HERO_IMAGE =
    process.env.REACT_APP_LOGIN_HERO_IMAGE || '/images/general-claire-login.png';

const CLAIRE_PROD_DEVICE_API_URL = 'https://ai-service.dev.us.hotelworld.ai';

const normalizeApiBaseUrl = (url?: string) =>
    (url || '').trim().replace(/\/$/, '');

/** Dashboard id sent to Claire auth/sign-up APIs based on device service env. */
export const getClaireDashboardId = (): string =>
    normalizeApiBaseUrl(DEVICE_INFO_API_URL) ===
    normalizeApiBaseUrl(CLAIRE_PROD_DEVICE_API_URL)
        ? 'Claire-glen-ivy-prod'
        : 'Claire-glen-ivy-test';

export const CLAIRE_DASHBOARD_ID = getClaireDashboardId();
